

exports.__esModule = true;
exports.$VenmoOnboardModel = undefined;

var _squid = require('squid');

var $VenmoOnboardModel = exports.$VenmoOnboardModel = _squid.$Model.extend('$VenmoOnboardModel', {
    api: new _squid.$Api({
        uri: '/api/venmo/onboard'
    })
});

angular.value("$VenmoOnboardModel", $VenmoOnboardModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ./components/xo-venmo-components/src/venmo-models/index.js
// module id = ./components/xo-venmo-components/src/venmo-models/index.js
// module chunks = 1